import React, {useState} from 'react';
import TopNavbar from './NavBar/TopNavbar';
import MenuSidebar from './NavBar/MenuSidebar';
import {Outlet} from 'react-router-dom';
import SPLogo from '../assets/SP_Logo.svg';

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="h-screen flex flex-col bg-gray-100 text-black font-sans overflow-hidden">
            {/* Header */}
            <TopNavbar onBurgerClick={() => setSidebarOpen(true)}/>

            {/* Sidebar Overlay */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-gray-900 bg-opacity-20 backdrop-blur-sm z-30 transition-opacity duration-300"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            {/* Sidebar */}
            <MenuSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>

            {/* Main Content */}
            <div className="flex-1 relative z-10 overflow-hidden flex flex-col">
                <div className="flex-1 h-full w-full px-10 py-10 overflow-hidden">
                    <Outlet/>
                </div>
            </div>
            <div className="absolute bottom-0 right-8 flex items-center space-x-2">
                <img src={SPLogo} alt="SP Logo" className="h-5 w-5 align-middle mb-3"/>
                <p className="text-gray-400 text-sm leading-none">Copyright by SolidPulse Software</p>
            </div>
        </div>
    );
};

export default Layout;
